import { useCheckUserCountry } from '@src/utils/useCheckUserCountry'
import { useCurrentUser, SitePreference } from '@utils/useCurrentUser'
import countriesMap from '@localization/countries.json'
import { loginRoute, useRouter } from '@src/routes'

const PII_COUNTRY_CODES = [
  countriesMap.KR.countryCode,
  countriesMap.TH.countryCode,
  countriesMap.VN.countryCode,
  countriesMap.PH.countryCode,
]

export function useShouldShowTermsModal() {
  const { getSitePreference, userIsLoggedIn, isB2BUser } = useCurrentUser()
  const router = useRouter()
  const isLoginPage = router.pathname.includes(loginRoute.index())

  const isPiiUser = PII_COUNTRY_CODES.map((code) =>
    useCheckUserCountry(code)
  ).some(Boolean)

  const generalTermsAccepted = getSitePreference(
    SitePreference.GeneralTermsCondition
  )
  const siteAgreementAccepted = getSitePreference(SitePreference.SiteAgreement)
  const piiConsentAccepted = getSitePreference(
    SitePreference.PiiDataConsentAcceptance
  )

  const isChinaUser = useCheckUserCountry(countriesMap.CN.countryCode)

  const shouldShowModal =
    userIsLoggedIn &&
    !isB2BUser &&
    !isLoginPage &&
    !isChinaUser &&
    (!generalTermsAccepted ||
      !siteAgreementAccepted ||
      (isPiiUser && !piiConsentAccepted))

  return {
    shouldShowModal,
    generalTermsAccepted,
    piiConsentAccepted,
  }
}
